/* eslint-disable prettier/prettier */
import { setStoreValue } from '@/store/utils';

export const SET_IS_FETCHING_USER_SETTINGS = "SET_IS_FETCHING_USER_SETTINGS";
export const SET_IS_ADDING_USER = "SET_IS_ADDING_USER";
export const SET_IS_EDITING_USER_DETAILS = "SET_IS_EDITING_USER_DETAILS";
export const SET_USER_SETTINGS = "SET_USER_SETTINGS";
export const SET_IS_FETCHING_USER_ROLES = "SET_IS_FETCHING_USER_ROLES";
export const SET_IS_FETCHING_USER_LOCATION_GROUPINGS = "SET_IS_FETCHING_USER_LOCATION_GROUPINGS";
export const SET_USER_LOCATION_GROUPINGS = "SET_USER_LOCATION_GROUPINGS";
export const SET_IS_FETCHING_USER_EXPERIENCE_FUNCTIONS = "SET_IS_FETCHING_USER_EXPERIENCE_FUNCTIONS";
export const SET_USER_EXPERIENCE_FUNCTIONS = "SET_USER_EXPERIENCE_FUNCTIONS";
export const SET_BOOKING_MANAGERS = "SET_BOOKING_MANAGERS";
export const SET_IS_FETCHING_BOOKING_MANAGERS = "SET_IS_FETCHING_BOOKING_MANAGERS";
export const SET_USER_DIVERSITY_TRAITS = "SET_USER_DIVERSITY_TRAITS";
export const SET_IS_FETCHING_USER_DIVERSITY_TRAITS = "SET_IS_FETCHING_USER_DIVERSITY_TRAITS";
export const SET_IS_FETCHING_USERS = "SET_IS_FETCHING_USERS";
export const SET_USERS = "SET_USERS";

const usersMutations = {
  [SET_USER_SETTINGS]: setStoreValue("userSettings"),
  [SET_IS_FETCHING_USER_SETTINGS]: setStoreValue("isFetchingUserSettings"),
  [SET_IS_ADDING_USER]: setStoreValue("isAddingUser"),
  [SET_IS_EDITING_USER_DETAILS]: setStoreValue("isEditingUserDetails"),
  [SET_IS_FETCHING_USER_ROLES]: setStoreValue("isFetchingUserRoles"),
  [SET_IS_FETCHING_USER_LOCATION_GROUPINGS]: setStoreValue("isFetchingUserLocationGroupings"),
  [SET_USER_LOCATION_GROUPINGS]: setStoreValue("userLocationGroupings"),
  [SET_IS_FETCHING_USER_EXPERIENCE_FUNCTIONS]: setStoreValue("isFetchingUserExperienceFunctions"),
  [SET_USER_EXPERIENCE_FUNCTIONS]: setStoreValue("userExperienceFunctions"),
  [SET_BOOKING_MANAGERS]: setStoreValue("bookingManagers"),
  [SET_IS_FETCHING_BOOKING_MANAGERS]: setStoreValue("isFetchingBookingManagers"),
  [SET_USER_DIVERSITY_TRAITS]: setStoreValue("userDiversityTraits"),
  [SET_IS_FETCHING_USER_DIVERSITY_TRAITS]: setStoreValue("isFetchingUserDiversityTraits"),
  [SET_USERS]: setStoreValue("users"),
  [SET_IS_FETCHING_USERS]: setStoreValue("isFetchingUsers")
};

export default usersMutations;
